import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getBaseGroups, deleteBaseGroup, getBaseGroup, updateBaseGroup } from 'actions/basegroups';
import { getSection } from 'actions/sections';
import User from '_class/User';
import { Button, Icon, Block, Flex } from '@haldor/ui';
import { Spinner } from 'UI';
import swal from 'sweetalert2';
import Modal from 'containers/Modals/Modal';
import BaseGroupForm from 'containers/BaseGroups/Form/BaseGroupForm';

var SectionBaseGroups = /*#__PURE__*/function (_Component) {
  _inherits(SectionBaseGroups, _Component);

  var _super = _createSuper(SectionBaseGroups);

  function SectionBaseGroups(props) {
    var _this;

    _classCallCheck(this, SectionBaseGroups);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var groupId = _this.props.match.params.groupId;

      if (_this.props.section == null || _this.props.section != null && _this.props.section.id != groupId) {
        _this.props.getSection(groupId).then(function () {
          _this.props.getBaseGroups(_this.props.section.id);
        });
      } else {
        _this.props.getBaseGroups(_this.props.section.id);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getUnassignedStudents", function () {
      var students = [];

      if (_this.props.active == null) {
        return students;
      }

      if (_this.props.section == null) {
        return students;
      }

      _this.props.section.students.forEach(function (student) {
        var _this$props$active;

        var isSelected = (_this$props$active = _this.props.active) === null || _this$props$active === void 0 ? void 0 : _this$props$active.units.find(function (unit) {
          return unit.memberships.find(function (member) {
            return student.userId == member.userId;
          });
        });

        if (isSelected != null) {
          return false;
        }

        students.push(student);
      });

      return students;
    });

    _defineProperty(_assertThisInitialized(_this), "toggleEditModal", function () {
      _this.setState({
        editModal: !_this.state.editModal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onBaseGroupSubmit", function (values) {
      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
          var _this$props$active2;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this.props.updateBaseGroup(values);

                case 2:
                  _this.setState({
                    editModal: false,
                    selectedBaseGroup: (_this$props$active2 = _this.props.active) === null || _this$props$active2 === void 0 ? void 0 : _this$props$active2.id
                  });

                  resolve(1);

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "deleteBaseGroup", function (baseGroup) {
      swal.fire({
        title: _this.props.translate('are-you-sure'),
        text: _this.props.translate('are-you-sure-you-want-to-delete'),
        showCancelButton: true,
        cancelButtonText: _this.props.translate('Cancel'),
        confirmButtonText: _this.props.translate('Yes')
      }).then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(result) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (result.value != null) {
                    _this.setState({
                      loading: true
                    });

                    _this.props.deleteBaseGroup(baseGroup.id).then(function () {
                      _this.setState({
                        loading: false
                      });
                    });
                  }

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "onBaseGroupSelect", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(event) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(event.target.value == null || event.target.value == '')) {
                  _context3.next = 3;
                  break;
                }

                _this.setState({
                  selectedBaseGroup: ''
                });

                return _context3.abrupt("return", false);

              case 3:
                _this.setState({
                  loading: true,
                  selectedBaseGroup: event.target.value
                });

                _context3.next = 6;
                return _this.props.getBaseGroup(event.target.value);

              case 6:
                _this.setState({
                  loading: false
                });

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "renderBaseGroup", function (baseGroup) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        },
        key: baseGroup.id
      }, baseGroup.units.map(function (unit, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: "unit",
          key: index
        }, /*#__PURE__*/React.createElement("span", {
          className: "title"
        }, unit.title), unit.memberships.map(function (membership) {
          var _membership$user, _membership$user2;

          return /*#__PURE__*/React.createElement("div", {
            key: membership.userId
          }, (_membership$user = membership.user) === null || _membership$user === void 0 ? void 0 : _membership$user.firstName, " ", (_membership$user2 = membership.user) === null || _membership$user2 === void 0 ? void 0 : _membership$user2.lastName);
        }));
      }));
    });

    _this.state = {
      loading: false,
      editModal: false,
      selectedBaseGroup: 0
    };
    return _this;
  }

  _createClass(SectionBaseGroups, [{
    key: "render",
    value: function render() {
      var user = new User(this.props.currentUser);
      var translate = this.props.translate;
      var unassignedStudents = this.getUnassignedStudents();
      return /*#__PURE__*/React.createElement("div", {
        className: "basegroups display"
      }, /*#__PURE__*/React.createElement(Modal, {
        title: translate('edit-basegroup'),
        isOpen: this.state.editModal,
        type: "small",
        onClose: this.toggleEditModal
      }, /*#__PURE__*/React.createElement("div", {
        className: "form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement(BaseGroupForm, {
        section: this.props.section,
        onSubmit: this.onBaseGroupSubmit,
        baseGroup: this.props.active
      })))), /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("h3", {
        style: {
          fontWeight: 400,
          marginBottom: '1rem'
        }
      }, this.props.translate('basegroups')), /*#__PURE__*/React.createElement("div", {
        className: "form"
      }, /*#__PURE__*/React.createElement(Flex, {
        center: true
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        },
        className: "select"
      }, /*#__PURE__*/React.createElement("select", {
        style: {
          padding: '.85rem 1rem'
        },
        value: this.state.selectedBaseGroup,
        onChange: this.onBaseGroupSelect
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, this.props.translate('select-basegroup')), this.props.baseGroups.map(function (baseGroup) {
        return /*#__PURE__*/React.createElement("option", {
          value: baseGroup.id,
          key: baseGroup.id
        }, baseGroup.title);
      }))), this.props.active != null ? /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 0,
          marginLeft: '1.25rem'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.toggleEditModal
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Pen_Small"
      }), this.props.translate('Edit'))) : null)), this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : this.props.active != null ? this.renderBaseGroup(this.props.active) : null, unassignedStudents.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "unit"
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('unassigned-students')), unassignedStudents.map(function (student, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: student.userId
        }, student.firstName, " ", student.lastName);
      })) : null));
    }
  }]);

  return SectionBaseGroups;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser,
    section: state.sections.activeSection,
    baseGroups: state.BaseGroups.baseGroups,
    active: state.BaseGroups.baseGroup
  };
}

export default withRouter(connect(mapStateToProps, {
  getBaseGroups: getBaseGroups,
  deleteBaseGroup: deleteBaseGroup,
  getBaseGroup: getBaseGroup,
  updateBaseGroup: updateBaseGroup,
  getSection: getSection
})(SectionBaseGroups));